import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useRef, useState, } from 'react';
import { useBox } from 'shared/hooks/utils';
import { RadioModule, RadioSensor } from 'z3k-config';
import { unpack_validation } from 'z3k-parser/validation/types';
import { radio_sensors_state_selector } from 'console/device-settings/z3k/components/utils/z3k-state';
import { DisplayRadioSensorState } from 'z3k-settings/components/radio/radiosensors/868/components/display-radio-sensor-state';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
import { Z3KSettings, Z3KSettingsEditor, Z3KSettingsState, } from 'console/device-settings/z3k/provider/types';
import { Z3kDragDropContainer } from '../../utils/drag-drop-drawer/container';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { DragDropDrawer } from '../../utils/drag-drop-drawer/component';
export function RadioRelaysList() {
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const { addIdToBlacklist } = useContext(Z3KSettings);
    const { z3k_state } = useContext(Z3KSettingsState);
    const configBox = useBox(config);
    const counter = useBox(0);
    const [rm_id, setRadioModuleId] = useState(null);
    const deleteRsTimeoutRef = useRef();
    useEffect(() => {
        return () => {
            if (deleteRsTimeoutRef.current) {
                clearTimeout(deleteRsTimeoutRef.current);
            }
        };
    }, []);
    const clearTimer = useCallback(() => {
        const timerId = deleteRsTimeoutRef.current;
        if (timerId) {
            deleteRsTimeoutRef.current = undefined;
            clearTimeout(timerId);
            counter.current = 0;
            setRadioModuleId(null);
        }
    }, [clearTimeout, deleteRsTimeoutRef, setRadioModuleId]);
    const onDeleteRadioSensor = useCallback((rs, new_list) => {
        addIdToBlacklist(rs.id);
        replace_config({
            ...findAndChangeLinks(configBox.current, rs.id),
            radiosensors: new_list,
        });
        if (rm_id === rs.related_radiomodule_id) {
            deleteRsTimeoutRef.current = setTimeout(clearTimer, 5000);
        }
    }, [addIdToBlacklist, replace_config, rm_id, clearTimer]);
    const radio_sensors_state = radio_sensors_state_selector(config, z3k_state);
    const displayStateField = useCallback((sensor) => (_jsx(DisplayRadioSensorState, { sensor: sensor, radio_sensors_state: radio_sensors_state })), [radio_sensors_state]);
    const childrenItem = (selected_item_id) => {
        return (_jsx(DragDropDrawer, { z3k_name: "radiosensors", name: RouteNaming[Z3kSecondRoutes.radiorelay], hideAddButton: true, item_url: Z3kSecondRoutes.radiorelay, enableDnd: true, objectFilter: RadioSensor.isRelaySensor, onDelete: onDeleteRadioSensor, titleComponentRender: displayStateField, selected_item_id: selected_item_id }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
const fields = ['radiosensors'];
RadioRelaysList.isError = (validation_result) => {
    return fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
};
RadioRelaysList.isWarning = RadioRelaysList.isError;
RadioRelaysList.isShown = (is_service_view, config, device_spec, is_staff, is_climatic) => {
    return (!is_climatic &&
        device_spec.io.has_radiosensors &&
        RadioModule.get.all(config).length > 0);
};
